import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function LightsCard({ thumbnails, name, water, productsId, ...rest }) {
  const navigate = useNavigate();
  const currentIndex = 0;

  const handleClick = () => {
    navigate(`/products/detail/${productsId}`);
  };

  const iconBoxStyle = {
    backgroundColor: "rgba(104, 52, 155, 1)", // 고효율 색상
    borderRadius: "8px", // 둥근 모서리
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // 그림자
    textAlign: "center",
    height: { xs: "25px", sm: "30px", md: "35px" }, // 모바일, 태블릿, 데스크톱별 높이
    minWidth: { xs: "40px", sm: "70px", md: "80px" }, // 모바일, 태블릿, 데스크톱별 너비
    padding: { xs: "2px 8px", sm: "3px 10px", md: "5px 12px" }, // 패딩
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "default",
  };

  const imageTemplate = (
    <MKBox
      bgColor="white"
      borderRadius="xl"
      shadow="lg"
      minHeight="10rem"
      sx={{
        overflow: "hidden",
        transform: "perspective(999px) rotateX(0deg) translate3d(0, 0, 0)",
        transformOrigin: "50% 0",
        backfaceVisibility: "hidden",
        willChange: "transform, box-shadow",
        transition: "transform 200ms ease-out",
        "&:hover": {
          transform: "perspective(999px) rotateX(7deg) translate3d(0px, -4px, 5px)",
        },
        cursor: "pointer",
        position: "relative",
      }}
      onClick={handleClick}
      {...rest}
    >
      {/* 아이콘 컨테이너 */}
      <MKBox
        position="absolute"
        top={10}
        right={10}
        display="flex"
        flexDirection="column"
        gap={1} // 아이콘 간 간격
        minWidth={{ xs: "50px", sm: "65px", md: "80px" }}
        height={{ xs: "60px", sm: "70px", md: "80px" }}
        justifyContent="space-between" // 아이콘 간 간격 균등
      >
        {water && (
          <MKBox sx={{ ...iconBoxStyle, backgroundColor: "rgba(52, 152, 219, 1)" }}>
            <MKTypography
              variant="button"
              color="white"
              sx={{
                fontSize: { xs: "0.75rem", sm: "0.9rem", md: "1rem" }, // 모바일, 태블릿, 데스크톱
                fontWeight: "bold",
                textTransform: "uppercase",
              }}
            >
              방습
            </MKTypography>
          </MKBox>
        )}
      </MKBox>

      {/* 현재 이미지 표시 */}
      <MKBox
        component="img"
        src={thumbnails[currentIndex]}
        alt={name}
        width="100%"
        my="auto"
        sx={{
          objectFit: "contain",
        }}
      />
    </MKBox>
  );

  return (
    <MKBox position="relative">
      {imageTemplate}
      {name ? (
        <MKBox mt={1} ml={1} lineHeight={1}>
          {name && (
            <MKTypography
              variant="h6"
              fontWeight="bold"
              sx={{
                fontSize: { xs: "0.75rem", sm: "1rem", md: "1.25rem" },
              }}
            >
              {name}
            </MKTypography>
          )}
        </MKBox>
      ) : null}
    </MKBox>
  );
}

LightsCard.defaultProps = {
  name: "",
  energy: false,
  water: false,
  route: "/",
  thumbnails: [],
};

LightsCard.propTypes = {
  thumbnails: PropTypes.arrayOf(PropTypes.string).isRequired,
  name: PropTypes.string,
  energy: PropTypes.bool,
  water: PropTypes.bool,
  route: PropTypes.string,
  productsId: PropTypes.string,
};

export default LightsCard;
